var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkUsersStreamlineUltimate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Network-Users--Streamline-Ultimate",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Network Users Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Network-Users--Streamline-Ultimate.svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.87 17.12a2.54 2.54 0 1 0 5.08 0 2.54 2.54 0 1 0 -5.08 0",
    fill: "#0F2651",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41 20.26a4.13 4.13 0 0 0 -4.15 3 0.51 0.51 0 0 0 0.19 0.5 1 1 0 0 0 0.65 0.24h6.63a1 1 0 0 0 0.64 -0.22 0.51 0.51 0 0 0 0.19 -0.5 4.12 4.12 0 0 0 -4.15 -3.02Z",
    fill: "#0F2651",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.05 17.12a2.54 2.54 0 1 0 2.54 -2.53 2.54 2.54 0 0 0 -2.54 2.53Z",
    fill: "#0F2651",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.59 20.26a4.12 4.12 0 0 0 -4.15 3 0.51 0.51 0 0 0 0.19 0.5 1 1 0 0 0 0.64 0.22h6.63a1 1 0 0 0 0.65 -0.22 0.51 0.51 0 0 0 0.19 -0.5 4.13 4.13 0 0 0 -4.15 -3Z",
    fill: "#0F2651",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0a8 8 0 1 0 8 8 8 8 0 0 0 -8 -8Zm6.15 7.11h-2.76a11.19 11.19 0 0 0 -1.57 -5.06 6.23 6.23 0 0 1 4.33 5.06ZM12 13.49a9.11 9.11 0 0 1 -1.61 -4.6h3.22a9.11 9.11 0 0 1 -1.61 4.6Zm-1.61 -6.38A9.11 9.11 0 0 1 12 2.51a9.11 9.11 0 0 1 1.61 4.6Zm-0.21 -5.06a11.19 11.19 0 0 0 -1.57 5.06H5.85a6.23 6.23 0 0 1 4.33 -5.06ZM5.85 8.89h2.76A11.19 11.19 0 0 0 10.18 14a6.23 6.23 0 0 1 -4.33 -5.11Zm8 5.06a11.19 11.19 0 0 0 1.57 -5.06h2.76A6.23 6.23 0 0 1 13.82 14Z",
    fill: "#0F2651",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkUsersStreamlineUltimate);
export default __webpack_public_path__ + "static/media/Network-Users--Streamline-Ultimate.c89a8d724e6f5d9fc054255f2cb907cb.svg";
export { ForwardRef as ReactComponent };